import { render } from "./DocsExample.vue?vue&type=template&id=501ff3b5"
import script from "./DocsExample.vue?vue&type=script&lang=js"
export * from "./DocsExample.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Documents\\PROYECTOS\\NEURALIA\\FrontNeuralia\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__